import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { sharedApi, getAuthToken } from "../../services/sharedApi";
import { toApiError } from "../../utils/errorUtils";

import type { RootState } from "..";
import type { ApiError } from "../../utils/errorUtils";
import type { AiBudgetStatus } from "@lingoshade/domain";

interface AiBudgetState {
  status: AiBudgetStatus | null;
  loading: boolean;
  error: ApiError | null;
}
const initialState: AiBudgetState = {
  status: null,
  loading: false,
  error: null,
};

export const fetchAiBudget = createAsyncThunk<
  AiBudgetStatus,
  string | void,
  { state: RootState; rejectValue: ApiError }
>(
  "aiBudget/fetch",
  async (
    language,
    { rejectWithValue },
  ): Promise<AiBudgetStatus | ReturnType<typeof rejectWithValue>> => {
    try {
      return await sharedApi.limits.getAiBudget(
        getAuthToken(),
        language || undefined,
      );
    } catch (error: unknown) {
      return rejectWithValue(toApiError(error));
    }
  },
  { condition: (_, { getState }): boolean => !getState().aiBudget.loading },
);

const slice = createSlice({
  name: "aiBudget",
  initialState,
  reducers: { resetAiBudget: (): AiBudgetState => initialState },
  extraReducers: (builder): void => {
    builder.addCase(fetchAiBudget.pending, (state): void => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchAiBudget.fulfilled, (state, action): void => {
      state.loading = false;
      state.status = action.payload;
    });
    builder.addCase(fetchAiBudget.rejected, (state, action): void => {
      state.loading = false;
      state.error = action.payload ?? null;
    });
  },
});
export const { resetAiBudget } = slice.actions;
export default slice.reducer;
